import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SEO_BY_LANGUAGE = {
  et: {
    title: 'MotoNurk motomuuseum — Muuseumiöö Narvas',
    description: 'MotoNurk motomuuseum Narvas: Muuseumiöö, vanasõidukid, kultuuriprogramm ja sündmuste galeriid. Külastage meid aadressil Vestervalli 17a.',
    locale: 'et_EE',
  },
  ru: {
    title: 'Мотомузей MotoNurk — Ночь музеев в Нарве',
    description: 'Мотомузей MotoNurk в Нарве: Ночь музеев, ретротехника, культурная программа и галереи событий. Наш адрес: Vestervalli 17a.',
    locale: 'ru_EE',
  },
  en: {
    title: 'MotoNurk Motorcycle Museum — Museum Night in Narva',
    description: 'MotoNurk motorcycle museum in Narva: Museum Night, vintage vehicles, cultural programme and event galleries. Visit us at Vestervalli 17a.',
    locale: 'en_GB',
  },
  lv: {
    title: 'MotoNurk motomuzejs — Muzeju nakts Narvā',
    description: 'MotoNurk motomuzejs Narvā: Muzeju nakts, retro transportlīdzekļi, kultūras programma un pasākumu galerijas. Vestervalli 17a.',
    locale: 'lv_LV',
  },
};

const setMeta = (selector, attribute, value) => {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
};

const Seo = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const language = i18n.resolvedLanguage || i18n.language || 'et';
    const seo = SEO_BY_LANGUAGE[language] || SEO_BY_LANGUAGE.et;

    document.documentElement.lang = language;
    document.title = seo.title;
    setMeta('meta[name="description"]', 'content', seo.description);
    setMeta('meta[property="og:title"]', 'content', seo.title);
    setMeta('meta[property="og:description"]', 'content', seo.description);
    setMeta('meta[property="og:locale"]', 'content', seo.locale);
    setMeta('meta[name="twitter:title"]', 'content', seo.title);
    setMeta('meta[name="twitter:description"]', 'content', seo.description);
  }, [i18n, i18n.language, i18n.resolvedLanguage]);

  return null;
};

export default Seo;
